import { render, staticRenderFns } from "./SnapshotImage.vue?vue&type=template&id=0507d476&scoped=true&"
import script from "./SnapshotImage.vue?vue&type=script&lang=ts&"
export * from "./SnapshotImage.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotImage.vue?vue&type=style&index=0&id=0507d476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507d476",
  null
  
)

export default component.exports